import { apiFetch } from './client';

export type AnalyticsRange = '7d' | '30d' | '90d';

export interface AnalyticsSeriesPoint {
  readonly date: string;
  readonly views: number;
  readonly uniques: number;
}

export interface AnalyticsOverview {
  readonly range: AnalyticsRange;
  readonly totals: {
    readonly views: number;
    readonly uniques: number;
  };
  readonly series: ReadonlyArray<AnalyticsSeriesPoint>;
}

export interface AnalyticsTopItem {
  readonly key: string;
  readonly count: number;
}

export const analyticsApi = {
  overview(range: AnalyticsRange): Promise<AnalyticsOverview> {
    return apiFetch<AnalyticsOverview>('/analytics/overview', { searchParams: { range } });
  },

  referrers(range: AnalyticsRange, limit = 10): Promise<AnalyticsTopItem[]> {
    return apiFetch<AnalyticsTopItem[]>('/analytics/referrers', {
      searchParams: { range, limit },
    });
  },

  countries(range: AnalyticsRange, limit = 20): Promise<AnalyticsTopItem[]> {
    return apiFetch<AnalyticsTopItem[]>('/analytics/countries', {
      searchParams: { range, limit },
    });
  },
};
